module.exports = __webpack_public_path__ + "img/client_icon_01_en.d75281d8.png";